import type { ReactNode } from 'react'

import { CodeBadge, Section, StatusBadge } from '@/features/report/reconcile/parts'
import { ISSUE_CODES, RECORD_STATUSES } from '@/lib/kantar-dia'
import { messages } from '@/lib/messages'

const g = messages.reconcile.guide

function Row({ badge, children }: { badge: ReactNode; children: ReactNode }) {
  return (
    <li className="grid gap-1 px-4 py-3 sm:grid-cols-[16rem_1fr] sm:gap-4">
      <span>{badge}</span>
      <span className="text-muted-foreground text-sm">{children}</span>
    </li>
  )
}

/** Kodların ve durumların anlamı; yalnız bilgi (sayı ve tıklanacak bir şey yok). */
export function GuideTab() {
  const errors = ISSUE_CODES.filter((code) => code.startsWith('H-'))
  const warnings = ISSUE_CODES.filter((code) => code.startsWith('U-'))
  return (
    <div className="flex flex-col gap-4">
      <Section title={g.errors}>
        <p className="text-muted-foreground border-border border-b px-4 py-2 text-xs">
          {g.errorsHint}
        </p>
        <ul className="divide-border divide-y">
          {errors.map((code) => (
            <Row key={code} badge={<CodeBadge code={code} />}>
              {g.codes[code]}
            </Row>
          ))}
        </ul>
      </Section>
      <Section title={g.warnings}>
        <p className="text-muted-foreground border-border border-b px-4 py-2 text-xs">
          {g.warningsHint}
        </p>
        <ul className="divide-border divide-y">
          {warnings.map((code) => (
            <Row key={code} badge={<CodeBadge code={code} />}>
              {g.codes[code]}
            </Row>
          ))}
        </ul>
      </Section>
      <Section title={g.statuses}>
        <p className="text-muted-foreground border-border border-b px-4 py-2 text-xs">
          {g.manualHint}
        </p>
        <ul className="divide-border divide-y">
          {RECORD_STATUSES.map((status) => (
            <Row key={status} badge={<StatusBadge status={status} />}>
              {g.statusHelp[status]}
            </Row>
          ))}
        </ul>
      </Section>
    </div>
  )
}
